import { IDS } from '../requirements-assessment-action-id.constants';
import { GridController, gridTpl } from '../../../../common/grid/grid.controller';
import * as Actions from '../requirements-assessment.actions';
import get from 'lodash/get';

class EvidenceGroupsGrid extends GridController {
    constructor($ngRedux, $state, NavigationService, $filter, $mdDialog, $scope, AuthService) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$scope = $scope;
        this.AuthService = AuthService;
    }

    $onInit() {
        this.filterComponent = false;
        this.exportComponent = false;
        this.title = false;
        this.icon = false;
        const user = this.AuthService.getUser();
        this.isAdmin = user.type === 'Administrator';

        this.columns = [
            {title: '#',                                                    mapper: null},
            {title: 'Number',                                               mapper: 'doc_num'},
            {title: 'Type',                                                 mapper: 'levelAndType'},
            {title: this.$filter('translate')('COMMON.FIELD.NAME'),         mapper: 'name'},
            {title: this.$filter('translate')('COMMON.FIELD.UPLOADED_BY'),  mapper: 'uploaded_by'},
            {title: this.$filter('translate')('COMMON.FIELD.UPLOADED_AT'),  mapper: 'uploaded_at'},
            {title: this.$filter('translate')('COMMON.FIELD.STATUS'),       mapper: 'status_name'},
            {title: this.$filter('translate')('COMMON.BUTTON.DOWNLOAD'),    mapper: 'download'},
        ];
        this.columnsDefault = this.columns.concat();
        this.unsubscribe = this.$ngRedux.connect(this.mapState().bind(this), Actions)(this);
        this.unsubscribeCustom = this.$ngRedux.connect(state => {
            const {rcoRequirementsAssessment, selectedRequirement, } = state.accreditation;
            const requirementStatus = selectedRequirement && selectedRequirement.status;
            if(['pen','sub'].includes(requirementStatus)) {
                    this.buttons = this.createButtons();
            }
            else
                this.buttons = this.buttons.filter(item => item.class !== 'btnGridRemove');

            return {
                selectedSiteLocation: rcoRequirementsAssessment?.selectedSiteLocation,
                auditIsScheduled:     selectedRequirement?.requirement_page_status !== 'mis',
                assessmentEnabled:    this.isAdmin || !!rcoRequirementsAssessment.auditors?.find(item => item.assignee_uuid === user.uuid),
            }

        }, {})(this);

        this.dataAction = this.fetchEvidenceGroupsProgressGrid;
        this.buttons = this.createButtons();
        this.init();
    }

    isDocumentShared(document) {
        return ['Default','Head Office'].includes(document.level);
    }

    isSelectedSiteLocation() {
        return !!get(this.selectedSiteLocation, 'uuid');
    }

    createButtons() {
        return [
            // {
            //     name: 'upload',
            //     class: 'btnGridAction',
            //     label: this.$filter('translate')('COMMON.BUTTON.UPLOAD'),
            //     callback: this.onUploadButton,
            //     filter: item =>  true //item.statusCode === 'pen'
            // },
            {
                name: 'approve',
                class: 'btnGridModify',
                label: this.$filter('translate')('COMMON.BUTTON.APPROVE'),
                callback: this.onApproveButton,
                filter: item =>
                    this.auditIsScheduled
                    && !!item.vdo_uuid
                    && item.is_enabled
                    && item.status_code !== 'app'
                    && this.assessmentEnabled
            },
            {
                name: 'reject',
                class: 'btnGridDispose',
                label: this.$filter('translate')('COMMON.BUTTON.REJECT'),
                callback: this.onRejectButton,
                filter: item =>
                    this.auditIsScheduled
                    && !!item.vdo_uuid
                    && item.is_enabled
                    && (item.status_code !== 'nap' || item.doc_revision_task_status_code === 'cpl')
                    && this.assessmentEnabled
            },
            {
                class: 'btnGridAction',
                label: 'Details',
                callback: this.onDetails,
                filter: item => this.isDocumentShared(item) === false
                    || item.is_enabled,
            },
            {
                name: 'remove',
                class: 'btnGridRemove',
                label: 'Remove',
                callback: event => {
                    this.onRemoveWithConfirm(event)
                },
                filter: item => this.isAdmin
                    && this.isDocumentShared(item) === false,
            },
            {
                class: 'btnGrid',
                label: 'Mark N/A',
                callback: this.onNotApplicable,
                filter: item => (this.isAdmin || this.isAuditor)
                    && this.isSelectedSiteLocation()
                    && this.isDocumentShared(item)
                    && item.is_enabled,
            },
            {
                class: 'btnGrid',
                label: 'Unmark N/A',
                callback:  this.onApplicable,
                filter: item => (this.isAdmin || this.isAuditor)
                    && this.isDocumentShared(item)
                    && item.is_enabled === false,
            }
        ];
    }

    $onDestroy() {
        if(this.unsubscribeCustom)
            this.unsubscribeCustom();

        this.destroy();
    }

}

EvidenceGroupsGrid.$inject = ['$ngRedux', '$state', 'NavigationService', '$filter', '$mdDialog', '$scope', 'AuthService'];

export const evidenceGroupsGrid = {
    bindings: {
        module: "<",
        identifier: "<",
        statePath: "<",
        isAuditor: "<",
        onDetails: "&",
        onApproveButton: "&",
        onRejectButton: "&",
        onSelect: "&",
        onApplicable: "&",
        onNotApplicable: "&",
    },
    controller: EvidenceGroupsGrid,
    ...gridTpl
}
